// -----------------------------------------------------------------
// <copyright
//   file="Izenda.ConnectionList.js"
//   company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// -----------------------------------------------------------------

import { getOr } from 'lodash/fp';
import FileUploadPopup from 'share/components/controls/FileUploadPopup/Izenda.FileUploadPopup';
import constants from 'logic/data/Izenda.ConnectionConstants';
import ConnectionDetail from 'logic/models/Izenda.ConnectionDetail';
import ConnectionDetailStore from 'logic/Izenda.ConnectionDetailStore';

export default class ConnectionUtils {

  /**
   * Checks whether current connection detail belongs to given db type or not.
   * @param {string} dbTypeId
   * @param {string} targetDbTypeShortName
   * @param {ConnectionStore} connectionStore
   * @returns {boolean}
   */
  static isDbType(dbTypeId, targetDbTypeShortName, connectionStore) {
    if (!dbTypeId || !targetDbTypeShortName)
      return false;
    const serverType = connectionStore.findDbTypeInList(dbTypeId);
    return !!(
      serverType
      && serverType.shortName
      && serverType.shortName.toUpperCase() === targetDbTypeShortName.toUpperCase()
    );
  }

  /**
   * Open excel file upload popup
   * @param {function} openPopup Open popup function from props
   * @param {function} confirmMessage ConfirmMessage function from props
   * @param {ConnectionDetailStore} connectionDetailStore
   * @returns {Promise}
   */
  static openUploadExcelPopup({ openPopup }, connectionDetailStore) {
    return new Promise((resolve, reject) => {
      const connectionDetail: ConnectionDetail = connectionDetailStore.item;
      openPopup(FileUploadPopup, {
        fileExtentions: constants.EXCEL_FILE_EXTENSIONS,
        url: connectionDetailStore.getUploadUrl(),
        params: {
          batchId: String.newGuid(),
          connectorId: getOr(constants.EMPTY_GUID, 'serverTypeId', connectionDetail), // send current serverTypeId
          connectionId: getOr(constants.EMPTY_GUID, 'id', connectionDetail)
        },
        // Success handler
        onSuccess: result => {
          const { success } = result;
          if (!success) {
            const messageText = getOr(null, 'messages[0].messages[0]', result);
            reject(new Error(messageText));
          } else {
            const connectionString = getOr(null, 'data.connectionString', result);
            connectionDetailStore.masterStore.addTempExcelFileToDeleteQueue(connectionString);
            resolve(connectionString);
          }
          return connectionString;
        },
        // Error handler
        onError: err => {
          reject(err);
          return err;
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Connection/Izenda.ConnectionUtils.js